export const GET_STATUSES = {
  START: "STATUSES/GET_STATUSES_START",
  SUCCESS: "STATUSES/GET_STATUSES_SUCCESS",
  ERROR: "STATUSES/GET_STATUSES_ERROR",
  CLEAR: "STATUSES/CLEAR_STATUSES",
};
